module.exports = __webpack_public_path__ + "img/empty.240e5990.png";